import { Courses } from './types'

export const FETCH_COURSES = 'FETCH_COURSES'
export const fetchCoursesAction = (courses: Courses) => {
    return {
        type: 'FETCH_COURSES',
        payload: courses,
    }
}
